import React from "react";
import { object, array, number, string } from "prop-types";
import { Link, ResponsiveImage } from "@quintype/components";
import StoryDate from "../../atoms/story-date";

import AuthorDefaultLogo from "../../atoms/author-default-img";
import Headline from "../../atoms/headline";

import "./story-card12.m.css";

const StoryCard12 = ({ story, headerLevel, headerType }) => {
  const author = story.authors[0];
  const name = author.name;
  const avatarURL = author["avatar-s3-key"];
  const authorAvatarUrl = author["avatar-url"];

  return (
    <div className="story-card story-card-12" styleName="story-card-12" id="story-card-12">
      <Link href={`/${story.slug}`}>
        <div styleName="author-wrapper">
          <div styleName="author-image">
            {avatarURL ? (
              <ResponsiveImage slug={avatarURL} aspectRatio={[1, 1]} width={80} height={80} alt={name.substring(1)} />
            ) : authorAvatarUrl ? (
              <img src={authorAvatarUrl} alt={name.substring(1)} width={80} height={80} />
            ) : (
              <AuthorDefaultLogo width={80} height={80} />
            )}
          </div>
          <div styleName="auth-info">
            <span styleName="title">{name}</span>
          </div>
        </div>

        <div styleName="card-content" className="card-content">
          <Headline text={story.headline} headerType={headerType} headerLevel={headerLevel} story={story} />
          <span styleName="summary" className="summary line-clamp-3">
            {story?.subheadline
              ? story?.subheadline
              : story.seo && story.seo["meta-description"]
                ? story.seo["meta-description"]
                : null}
          </span>
          <StoryDate story={story} />
        </div>
      </Link>
    </div>
  );
};

StoryCard12.defaultProps = {
  aspectRatio: [1, 1],
  imageType: "image16x9",
  headerType: 11,
  headerLevel: 2
};

StoryCard12.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number
};

export default StoryCard12;
